// extracted by mini-css-extract-plugin
export var choice = "Choice-module--choice--a08ad";